/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged, m11ReportSection01FoiChanged,
    m11ReportSection01ResourceChanged, selectM11ReportContainerFoi, selectM11ReportContainerResource,
    selectM11ReportSection01Foi, selectM11ReportSection01Resource, selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveProtocolSummaryChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section01State, setAlertModalState, setStartingSection01State) => {

    let changesStates = {
        section01State: section01State
    };
    let response = await saveM11Changes(apiToken, 18, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection01Resource) {
            dispatch(m11ReportSection01ResourceChanged(response.m11ReportSection01Resource));
        }
        setStartingSection01State(JSON.parse(JSON.stringify(section01State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step018ProtocolSummary = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection01Foi = useSelector(selectM11ReportSection01Foi);
    const m11ReportSection01Resource = useSelector(selectM11ReportSection01Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section01State, setSection01State] = useState({
        "section12Status": "empty", "section12Xhtml": "",
        "section13Status": "empty", "section13Xhtml": ""
    });
    const [startingSection01State, setStartingSection01State] = useState({
        "section12Status": "empty", "section12Xhtml": "",
        "section13Status": "empty", "section13Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section01State, startingSection01State)),
        async saveAllChanges() {
            await saveProtocolSummaryChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section01State, setAlertModalState, setStartingSection01State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section12Status": "empty", "section12Xhtml": "",
                "section13Status": "empty", "section13Xhtml": "", "loaded": true
            };
            setSection01State(startingData);
            setStartingSection01State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[1]?.entry?.length) {
                let theFoi = getIdFromReference(m11ReportContainerResource.section[1].entry[0]);
                if (theFoi && !isNaN(theFoi) && theFoi !== m11ReportSection01Foi) {
                    dispatch(m11ReportSection01FoiChanged(theFoi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection01Foi && !isNaN(m11ReportSection01Foi)) {
            loadResource(m11ReportSection01Foi, "M11ReportSection01", apiToken, dispatch);
        }
    }, [m11ReportSection01Foi]);

    useEffect(() => {
        if (m11ReportSection01Resource && Object.keys(m11ReportSection01Resource).length > 0) {
            let startingData = {
                "section12Status": "empty", "section12Xhtml": "",
                "section13Status": "empty", "section13Xhtml": "", "loaded": true
            };
            if (m11ReportSection01Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection01Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section12Status = m11ReportSection01Resource.section[0].section[1].text.status;
                    startingData.section12Xhtml = m11ReportSection01Resource.section[0].section[1].text.div;
                }
                if (m11ReportSection01Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection01Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section13Status = m11ReportSection01Resource.section[0].section[2].text.status;
                    startingData.section13Xhtml = m11ReportSection01Resource.section[0].section[2].text.div;
                }
            }
            setSection01State(startingData);
            setStartingSection01State(startingData);
        }
    }, [m11ReportSection01Resource]);

    return <div>
        <h3>Complete Section 1 Protocol Summary</h3>
        {!(m11ReportSection01Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {section01State.loaded && <>
            <h4 style={{ marginBottom: "0px" }}>Revise the Section 1.2 Trial Schema summary as needed.</h4>
            <TextDivEntry elementName="section12Xhtml"
                startingValue={section01State.section12Xhtml}
                setResourceState={setSection01State} />
            <h4 style={{ marginBottom: "0px" }}>Revise the Section 1.3 Schedule of Activities summary as needed.</h4>
            <TextDivEntry elementName="section13Xhtml"
                startingValue={section01State.section13Xhtml}
                setResourceState={setSection01State} />
        </>}
    </div >
});

const M11Step018ProtocolSummaryHelperText = <div>
    <h3>Complete Section 1 Protocol Summary</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 1.2 Trial Schema.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>The purpose of this section is to provide a visual depiction of the trial design, orienting users of the protocol to the key features of the design.</p>
            <p>The schema depicts the trial arms, the flow of individual participant through the progression of trial period(s)/epochs (such as screening, washout/run-in, intervention, and key milestones [e.g., randomisation, cross-over, end of treatment, end of study, post-treatment follow-up]).</p>
            <p>For complex trials, additional schemas may be added to describe activities or trial periods in greater detail.</p>
        </div>
        <p>Enter data for Section 1.3 Schedule of Activities.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>The schedule of activities must capture the procedures that will be accomplished at each trial visit, and all contact with participants (e.g., telephone contacts). This includes any tests that are used for eligibility, participant randomisation or stratification, or decisions on trial intervention discontinuation. Allowable windows should be stated for all visits and procedures.</p>
            <p>A tabular format is recommended.</p>
            <p>When applicable for studies with extensive sampling (e.g., serial PK sampling), a separate table may be added.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step018ProtocolSummaryValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 18, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 18 (Complete Protocol Summary) {validationCheckState.step18numberOfChecks} issues checked. {validationCheckState.step18numberPassed} passed. {validationCheckState.step18numberFailed} failed.</h4>
        <p>Section 1 heading is 'PROTOCOL SUMMARY': {validationCheckState.resultCheckSection1Heading}</p>
        <p>Section 1 PROTOCOL SUMMARY does not have text: {validationCheckState.resultCheckSection1Text}</p>
        <p>Section 1.1 heading is 'Protocol Synopsis': {validationCheckState.resultCheckSection11Heading}</p>
        <p>Section 1.1 Protocol Synopsis does not have text: {validationCheckState.resultCheckSection11Text}</p>
        <p>Section 1.2 heading is 'Trial Schema': {validationCheckState.resultCheckSection12Heading}</p>
        <p>Section 1.2 Trial Schema has content: {validationCheckState.resultCheckSection12Content}</p>
        <p>Section 1.3 heading is 'Schedule of Activities': {validationCheckState.resultCheckSection13Heading}</p>
        <p>Section 1.3 Schedule of Activities has content: {validationCheckState.resultCheckSection13Content}</p>
   </div>}  </div>
}

export default M11Step018ProtocolSummary;
export { M11Step018ProtocolSummaryHelperText, M11Step018ProtocolSummaryValidationCheck };